import { render, staticRenderFns } from "./attendees.vue?vue&type=template&id=ffcabdc6&"
import script from "./attendees.vue?vue&type=script&lang=js&"
export * from "./attendees.vue?vue&type=script&lang=js&"
import style0 from "./attendees.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports